import { useTranslation } from "react-i18next";

import { css } from "@emotion/react";

import { ChevronLeftIcon, colors } from "@dotnet/telematics-design-system";

import ListChoice from "components/DesignComponents/ListChoice";

import { SetContentProps, TABLE_VIEW_CONTENT } from "./types";

const GoBack = ({ setContent }: SetContentProps) => {
    const { blue700, gray300, white } = colors;

    const { t } = useTranslation();

    return (
        <ListChoice
            title={t("Button##go back")}
            iconLeft={<ChevronLeftIcon />}
            onClick={() => setContent(TABLE_VIEW_CONTENT.Initial)}
            css={css({
                position: "sticky",
                top: "0",
                background: white,
                zIndex: "1",
                color: blue700,
                borderBottom: `1px solid ${gray300}`,
                paddingBottom: "11px"
            })}
        />
    );
};

export default GoBack;
